import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Row, Col, Container } from "reactstrap";
import Thumbnails from "../PageProductDetails/Detail/Thumbnails";
import {
  getAdditionalPage,
  doFetchProducts,
  editorsChoicePage,
} from "../../actions/productAction";
import { Link } from "react-router-dom";
import { normalizeBrand } from "../../utils/Helpers";
import { getCloudImageUrl, emptyImage } from "../../utils";
import emptySneakerImg from "../../images/emptysneakers2.png";
import emptyApparelImg from "../../images/emptyapparels.png";
import emptyHandbagImg from "../../images/emptyhandbags.png";
import fireIcon from "../../images/fire-product.png"

const previewSettings = {
  arrows: true,
  // autoplay:true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  lazyLoad: true,
  dots: false,
  swipe: false,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

class EditorsCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      availables: true,
      hasMoreData: false,
      currentIndex: 0,
    };
    this.changeImage = this.changeImage.bind(this);
  }

  componentDidMount() {
    this._getList();
  }

  _getList = (nextPage = null) => {
    const { page, availables } = this.state;
    const { dataCategory } = this.props;
    this.props.getEditorChoiceProducts({
      params: {
        page: nextPage === null ? page : nextPage,
        availables,
        category: dataCategory,
      },
    });
  };

  changeImage(currentIndex) {
    this.setState({ currentIndex: currentIndex });
    // const perPage = 16;
    // const i =  perPage -5;
  }

  _handleBeforeChange = (oldIndex, newIndex) => {
    if (newIndex > oldIndex) {
      const gap = newIndex - oldIndex;
      const bagi = Math.round(this.props.dataProduct.data.length / gap);
      const median = Math.round(bagi / 2) + (bagi % 2);
      // const a = parseInt(this.props.dataProduct.data.length * 0.75);
      if (newIndex === median * gap && this.state.hasMoreData) {
        const { page } = this.state;
        this.setState({ page: page + 1 });
        this._getList(page + 1);
      }
    }
  };

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.dataProduct.isFetch &&
      prevProps.dataProduct.isFetch !== this.props.dataProduct.isFetch
    ) {
      this.setState({
        hasMoreData: this.props.dataProduct.pagination !== null,
      });
    }
    if (prevProps.dataCategory !== this.props.dataCategory) {
      await this.setState({
        page: 1,
        hasMoreData: true,
      });
      this._getList();
    }
  }

  _renderItems(category, data) {
    const categoryUrl =
      category === "apparels" || category === "Apparels"
        ? "apparel"
        : category === "lifestyles"
          ? "electronics-collectibles"
          : category === "handbags" ? "luxury" : category;

    return data.map((item, index) => (
      <a
        href={`/${categoryUrl}/${item.id}/${item.slug}`}
        title={item.display_name}
        key={index}
        className="sneaker-item"
      >
        <KickImage
          alt={"Hot Product"}
          src={fireIcon}
          className="sneaker-item__hot-product"
        />
        <KickImage
          alt={item.display_name}
          src={item.img}
          className="sneaker-item__image editors"
        />
        <div className="sneaker-item__text">
          <p>{item.brand ? normalizeBrand(item.brand) : null}</p>
          <p>{item.display_name}</p>
          <p>starts from</p>
          <p>IDR {Number(item.price).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</p>
        </div>
      </a>
    ));
  }

  render() {
    const {
      dataProduct: { data },
      dataCategory,
    } = this.props;
    const categoryUrl =
      dataCategory === "apparels" || dataCategory === "Apparels"
        ? "apparel"
        : dataCategory === "handbags" ? "luxury" : dataCategory;
    if (data.length === 0) return null;
    return (
      <Container fluid className="editor-pick-container">
        <Row className="editor-top">
          <Col>
            <Container className="content-container">
              <h4 className="underline title black">
                <span>
                  <Link
                    to={`/${categoryUrl}/hot-products`}
                    target="_blank"
                    className="editors-release-style"
                  >
                    HOT PRODUCT
                  </Link>
                </span>
              </h4>
              <div className="sneaker-list">
                {data.length > 0 ? (
                  <Thumbnails
                    settings={previewSettings}
                    afterChange={this.changeImage}
                    beforeChange={this._handleBeforeChange}
                    thumbnails={data.map((item) => {
                      const brandName = item.product && item.product.brand ? (dataCategory === "lifestyles" ? (item.product.brand.title ? item.product.brand.title : item.product.brand.name) : item.product.brand.flat[0]) : ""
                      return {
                        id: item.id,
                        slug: item.slug,
                        img: item.product_variant_images.length
                          ? getCloudImageUrl(
                            item.product_variant_images[0].URL,
                            400
                          )
                          : emptyImage(dataCategory),
                        display_name: item.display_name,
                        brand: brandName,
                        price: item.price
                      };
                    })}
                    active={this.state.currentIndex}
                    renderItems={(data) =>
                      this._renderItems(dataCategory, data)
                    }
                  />
                ) : null}
              </div>
            </Container>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  dataProduct: {
    data: state.dataProduct.searchResult,
    pagination: state.dataProduct.pagination,
    isFetch: state.dataProduct.stillPending,
  },
  dataCategory: state.dataCategory.selected,
});

const mapDispatchToProps = (dispatch) => ({
  doFetchProducts: () => dispatch(doFetchProducts()),
  getEditorChoiceProducts: (params) =>
    dispatch(editorsChoicePage("editors-choices", params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditorsCarousel);
